/**
 * Manages slider toggle switches and their associated UI visibility
 * Handles enabling/disabling sliders and their corresponding displays
 */
export class SliderToggleManager {
  /**
   * @param {HTMLElement} rootElement - The root element containing slider controls
   */
  constructor(rootElement) {
    this.rootElement = rootElement
  }

  /**
   * Toggle a slider's visibility and enabled state
   * @param {HTMLInputElement} toggle - The toggle checkbox element
   */
  toggleSlider(toggle) {
    const container = toggle.closest('.slider-control-group')
    const slider = container?.querySelector('.dual-range-slider')
    const sliderValueDisplay = container?.querySelector('.slider-value-display')
    const minInput = slider?.querySelector('.slider-min')
    const maxInput = slider?.querySelector('.slider-max')
    const whenEnabled = container?.querySelector('.when-enabled')
    const whenDisabled = container?.querySelector('.when-disabled')

    if (toggle.checked) {
      // Enabled state - show slider and value
      if (minInput) minInput.disabled = false
      if (maxInput) maxInput.disabled = false
      if (slider) slider.classList.remove('d-none')
      if (sliderValueDisplay) sliderValueDisplay.classList.remove('d-none')
      if (whenEnabled) whenEnabled.classList.remove('d-none')
      if (whenDisabled) whenDisabled.classList.add('d-none')
    } else {
      // Disabled state - hide slider and value
      if (minInput) minInput.disabled = true
      if (maxInput) maxInput.disabled = true
      if (slider) slider.classList.add('d-none')
      if (sliderValueDisplay) sliderValueDisplay.classList.add('d-none')
      if (whenEnabled) whenEnabled.classList.add('d-none')
      if (whenDisabled) whenDisabled.classList.remove('d-none')
    }
  }

  /**
   * Reset all slider toggles to disabled (default state)
   */
  resetToDefaults() {
    this.rootElement.querySelectorAll('.slider-toggle').forEach(toggle => {
      toggle.checked = false
      const container = toggle.closest('.slider-control-group')
      const slider = container?.querySelector('.dual-range-slider')
      const sliderValueDisplay = container?.querySelector('.slider-value-display')
      const whenEnabled = container?.querySelector('.when-enabled')
      const whenDisabled = container?.querySelector('.when-disabled')
      if (slider) slider.classList.add('d-none')
      if (sliderValueDisplay) sliderValueDisplay.classList.add('d-none')
      if (whenEnabled) whenEnabled.classList.add('d-none')
      if (whenDisabled) whenDisabled.classList.remove('d-none')
    })
  }
}
